import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';

import { useSecretChatRequestAccessPopupPresenter } from './SecretChatRequestAccessPopup.presenter';
import styles from './SecretChatRequestAccessPopup.styles.m.css';
import { ISecretChatRequestAccessPopupProps } from './SecretChatRequestAccessPopup.types';
import { AccessRequestItem } from './components/AccessRequestItem/AccessRequestItem';
import { GlobalActionsButton } from './components/GlobalActionsButton/GlobalActionsButton';

export const SecretChatRequestAccessPopup: FC<
  ICommonPopupsProps<ISecretChatRequestAccessPopupProps>
> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useSecretChatRequestAccessPopupPresenter(props);

  return (
    <Popup
      isHidden={props.popupInstance.isHidden}
      title={t('secure_chat_requests_to_join_title')}
      isOpened
      onClose={presenter.onClose}
    >
      <div className={styles.headBlock}>
        <div className={styles.requestsCount}>
          {t('secure_chat_requests_to_join_count', { 0: presenter.permissionsRequestsCount })}
        </div>
        {presenter.permissionsRequestsCount > 1 && (
          <GlobalActionsButton
            onApproveAll={presenter.onApproveAll}
            onBlockAll={presenter.onBlockAll}
          />
        )}
      </div>
      <div className={styles.wrapper}>
        {presenter.permissionsRequests?.map((request) => (
          <AccessRequestItem
            key={request.deviceId}
            request={request}
            onApprove={presenter.onApprove}
            onBlock={presenter.onBlock}
          />
        ))}
      </div>
    </Popup>
  );
});
